/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_LaterInputs */

const en_update_later = /** @type {(inputs: Update_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const de_update_later = /** @type {(inputs: Update_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Später`)
};

/**
* | output |
* | --- |
* | "Later" |
*
* @param {Update_LaterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const update_later = /** @type {((inputs?: Update_LaterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_LaterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_update_later(inputs)
	return en_update_later(inputs)
});